"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Bank = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Bank = _ref => {
  let {
    color = "#13126C",
    strokeWidth = 2,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M3.765 22H22M2.455 22h19.09M6 12v7m6-7v7m6-7v7M12.006 2c-.298 0-.6.078-.893.239L2.223 7.52A.454.454 0 0 0 2 7.91v.637c0 .25.203.453.455.453h19.09A.453.453 0 0 0 22 8.547V7.91a.454.454 0 0 0-.222-.391l-8.892-5.28a1.787 1.787 0 0 0-.88-.24Z"
  }));
};
exports.Bank = Bank;
Bank.displayName = "Bank";